module.exports = __webpack_public_path__ + "static/media/ecc.e697d055.jpeg";